export const getLink = (tipo, id) => {
  switch (tipo) {
    case "Cargo Bancario":
      return `${origin}/Activos/cargo_bancario_edit.aspx?IdSec=${id}`;
    case "Gasto":
      return `${origin}/Contabilidad/gastos_edit.aspx?IdSec=${id}`;
    case "Fact. Suplidor":
      return `${origin}/CxP/factura_suplidor_edit.aspx?IdSec=${id}`;
    case "Cheques":
      return `${origin}/Activos/cheque_edit.aspx?IdSec=${id}`;
    case "Depósitos":
      return `${origin}/Activos/deposito_bancario_edit.aspx?IdSec=${id}`;
    case "Transferencias":
      return `${origin}/Activos/transferencia_bancaria_edit.aspx?IdSec=${id}`;
    case "Transferencia Bancaria":
      return `${origin}/Activos/transferencia_bancaria_edit.aspx?IdSec=${id}`;
    case "Recibo":
      return `${origin}/CxC/recibo_edit.aspx?IdSec=${id}`;
    case "Factura":
      return `${origin}/Facturacion/factura_edit.aspx?IdSec=${id}`;
    case "Factura Contado":
      return `${origin}/Facturacion/factura_edit.aspx?IdSec=${id}`;
    case "Nota de Crédito (CxC)":
      return `${origin}/CxC/nota_credito_cxc_edit.aspx?IdSec=${id}`;
    case "Nota de Débito (CxC)":
      return `${origin}/CxC/nota_debito_cxc_edit.aspx?IdSec=${id}`;
    case "Factura- Pro-Forma":
      return `${origin}/Facturacion/factura_proforma_edit.aspx?IdSec=${id}`;
    case "Anticipo":
      return `${origin}/CxC/anticipo_edit.aspx?IdSec=${id}`;
    case "Anticipo por Aplicar":
      return `${origin}/CxC/devolucion_anticipo_edit.aspx?IdSec=${id}`;
    default:
      return null;
  }
};
